export enum FeatureEntitlements {
  EversightCompetitiveIntel = 'eversight_competitive_intel',
}
